function ConfirmDeleteProfile() {
  return (
    <div className="flex flex-col items-center text-center">
      <h3 className="text-white text-xl font-bold mb-4">Delete Account</h3>

      <div className="bg-main-red-dark/20 border border-main-red-light/50 rounded-lg p-4 mb-4 w-full">
        <p className="text-main-red-light font-semibold mb-2">
          This action cannot be undone.
        </p>
        <p className="text-main-light-highlight text-sm">
          Deleting your account will permanently remove all your data, ride
          history, and preferences.
        </p>
      </div>

      <p className="text-main-light-highlight/60 text-sm">
        Account deletion is coming soon.
      </p>
    </div>
  );
}

export default ConfirmDeleteProfile;
